module.exports = __webpack_public_path__ + "img/serviceGuide-header-bg.d068410.png";